










































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FormBuilderField } from "../types/FormBuilderTypes";
import draggable from "vuedraggable";
import CanvasField from "./CanvasField.vue";

@Component({
  components: { draggable, CanvasField },
})
export default class FormCanvas extends Vue {
  @Prop({ required: true }) fields!: FormBuilderField[];
  @Prop({ default: null }) selectedFieldId!: string | null;

  public localFields: FormBuilderField[] = [];

  @Watch("fields", { immediate: true, deep: true })
  onFieldsChanged(newFields: FormBuilderField[]) {
    this.localFields = [...newFields];
  }

  public onDrop(event: DragEvent) {
    event.preventDefault();
    this.$emit("drop", event);
  }

  public selectField(fieldId: string) {
    this.$emit("select-field", fieldId);
  }

  public deleteField(fieldId: string) {
    this.$emit("delete-field", fieldId);
  }

  public onReorder() {
    this.$emit("reorder", this.localFields);
  }
}
